export enum EIntegrationPlatform {
  APPLE_HEALTH = "APPLE HEALTH",
  SPOTIFY = "SPOTIFY",
  BRITISH_LIBRABRY = "BRITISH LIBRABRY",
  F1 = "F1",
  FACEBOOK = "FACEBOOK",
  FAMILY_SEARCH = "FAMILY SEARCH",
  GOOGLE_CALENDAR = "GOOGLE CALENDAR",
  GOOGLE_MAPS = "GOOGLE MAPS",
  GOOGLE_PHOTOS = "GOOGLE_PHOTOS",
  INSTAGRAM = "INSTAGRAM",
  SAMSUMG_HEALTH = "SAMSUMG HEALTH",
  WIKIPEDIA = "WIKIPEDIA",
  X = "X",
}

export type TIntegration = {
  id: string;
  userId: string;

  accessToken: string;
  refreshToken: string;

  platform: EIntegrationPlatform;
  metadataPublic: any;

  refreshExpireAt: string;
  lastCheckAt: string;

  createdAt: string;
  updatedAt: string;
};
